
import { MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css"
import L from "leaflet";
import { alertIcon, placeholder } from "../assets/imgs"
import { useEffect, useState, useRef, Ref } from "react";

export interface MapBaseProps {
    zoom?: any;
    coordinates?: string;
    name?: string;
    getCoordinates?: Function;
    isInput: boolean;
}

const MapBase: React.FC<MapBaseProps> = ({ zoom, coordinates, name, getCoordinates, isInput }) => {

    const coordinatesArray = coordinates?.split(',');

    const [position, setPosition] = useState(
        {
            lat: coordinatesArray && parseFloat(coordinatesArray[0].trim())
                || 22.3767381,
            lng: coordinatesArray && parseFloat(coordinatesArray[1].trim())
                || 114.1855596
        }
    );
    const placeholderIcon = L.icon({ iconUrl: placeholder, iconSize: [38, 38] });

    //test
    function SetupMarker(e: any, map: any, markerRef: any) {
        if (isInput) {
            map.eachLayer(function (layer: any) {
                if (layer instanceof L.Marker) {
                    map.removeLayer(layer);
                }
            })
            const marker = L.marker({ lat: e.lat, lng: e.lng })
                .bindPopup(`${e.lat}, ${e.lng}`)
                .setIcon(placeholderIcon)
                .addTo(map);
            if (getCoordinates) {
                getCoordinates(`${e.lat}, ${e.lng}`);
                setPosition({ lat: e.lat, lng: e.lng });
            }
            markerRef.current.push(marker);
        }
    }

    function SetupMarker2(e: any, map: any, markerRef: any) {
        map.eachLayer(function (layer: any) {
            if (layer instanceof L.Marker) {
                map.removeLayer(layer);
            }
        })
        const marker = L.marker({ lat: e.lat, lng: e.lng })
            .bindPopup(`${e.lat}, ${e.lng}`)
            .setIcon(placeholderIcon)
            .addTo(map);
        markerRef.current.push(marker);
    }

    const Recenter = ({ lat, lng }: any) => {

        const map = useMap();
        const markerRef = useRef<any[]>([]);
        const handleEvent = (e: any) => {
            if (e.latlng != null && e.latlng.lat != null) {
                SetupMarker2({ lat: e.latlng.lat, lng: e.latlng.lng }, map, markerRef);
                if (getCoordinates) {
                    //getCoordinates(`${e.latlng.lat}, ${e.latlng.lng}`); 
                }
            }
        };

        useEffect(() => {
            SetupMarker2({ lat: lat, lng: lng }, map, markerRef);
            map.setView([lat, lng]);
        }, [coordinates]);

        if (isInput) { map.on('click', handleEvent); }
        return null;
    };

    useEffect(() => {
        if (coordinates) {
            const coordinatesArray = coordinates.split(',');
            if (coordinatesArray.length >= 2) {
                setPosition({ lat: parseFloat(coordinatesArray[0].trim()), lng: parseFloat(coordinatesArray[1].trim()) })
            }
        }
    }, [coordinates, getCoordinates])

    useEffect(() => {
        if (coordinates != null) {
            const coordinatesArray = coordinates.split(',');
            if (coordinatesArray.length >= 2) {
                setPosition({ lat: parseFloat(coordinatesArray[0].trim()), lng: parseFloat(coordinatesArray[1].trim()) })
            }
        }
    }, []);

    return (isInput ? (
        <>
            <MapContainer center={[position.lat, position.lng]} zoom={zoom} zoomAnimation={true} minZoom={10} style={{ width: '100%', height: '100%' }} dragging={true} scrollWheelZoom={true} doubleClickZoom={false}>
                <Recenter lat={position.lat} lng={position.lng} />
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url='https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=mNVo7cfW5z37vOy84x8P'
                />
            </MapContainer>
        </>
    ) : (
        <>
            <MapContainer center={[position.lat, position.lng]} zoom={zoom} style={{ width: '100%', height: '100%', zIndex: "0" }} dragging={false} scrollWheelZoom={false} doubleClickZoom={false}>
                {/* <Recenter lat={position.lat} lng={position.lng} /> */}
                <Recenter lat={position.lat} lng={position?.lng} />
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=mNVo7cfW5z37vOy84x8P"
                />
            </MapContainer>
        </>
    ))
}

export default MapBase;